<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" v-model="localVisible" :confirmLoading="loading" :maskClosable="false" @cancel="cancel" @ok="confirm">
      <div slot="title">{{ innerForm.id ? "编辑" : "新增" }}</div>
        <div style="max-height: 65vh; overflow-y: auto;border: 1px solid #277fd0 ; overflow-x: hidden;padding: 10px;margin: -10px">
        <a-form-model ref="form" :model="innerForm.others" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="product_name" label="产品名称">
            <a-select
                    v-model="innerForm.others.name"
                    style="width: 100%"
                    show-search
                    :filter-option="false"
                    @change="handleChangeProductName"
                    @search="handleProductSearch"
                    @popupScroll="handleProductPopupScroll"
            >
              <a-select-option
                      v-for="val in productList"
                      :key="val.id"
                      :value="val.name"
              >
                {{ val.name }} ({{ val.id }})
              </a-select-option>
              <a-select-option v-if="productHasMore" disabled key="loading" value="__loading__">
                <a-spin size="small" /> 加载中...
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="number" label="批次">
            <a-input v-model="innerForm.others.number" />
          </a-form-model-item>
          <a-form-model-item prop="produce_time" label="召回日期">
            <a-date-picker v-model="innerForm.others.produce_time" valueFormat="YYYY-MM-DD" style="width: 100%" />
          </a-form-model-item>
          <a-form-model-item prop="reason" label="召回原因">
            <a-textarea v-model="innerForm.others.reason" />
          </a-form-model-item>
          <a-form-model-item prop="situation" label="召回情况">
            <a-textarea v-model="innerForm.others.situation" />
          </a-form-model-item>
          <a-form-model-item prop="causing_harm" label="产生危害">
            <a-textarea v-model="innerForm.others.causing_harm" />
          </a-form-model-item>
          <a-form-model-item prop="rectification_plan" label="整改方案">
            <a-textarea v-model="innerForm.others.rectification_plan" />
          </a-form-model-item>
          <a-form-model-item prop="ID_image" label="相关文件">
            <Upload :ID_image="innerForm.others.ID_image" :count="5" @handleChange="handleChange" />
          </a-form-model-item>
          <a-form-model-item prop="contact" label="联系人">
            <a-input v-model="innerForm.others.contact" />
          </a-form-model-item>
          <a-form-model-item prop="phone" label="手机号">
            <a-input v-model="innerForm.others.phone" />
          </a-form-model-item>
          <a-form-model-item prop="email" label="邮箱">
            <a-input v-model="innerForm.others.email" />
          </a-form-model-item>
          <a-form-model-item prop="address" label="地址">
            <a-input v-model="innerForm.others.address" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-input v-model="innerForm.others.remark" allowClear />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import Upload from '../../../components/Upload/index1'
import { goodsInformationList } from '@/api/goods'
import { callBackAdd, callBackEdit } from "@/api/dispatch";

export default {
  name: "FormModal",
  model: { prop: "visible", event: "cancel" },
  components: {
    Upload
  },
  props: {
    visible: { type: Boolean, default: false },
    form: { type: Object, default: () => ({ others: { ID_image: [] } }) },
    clientsClassificationOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      uploadUrl: process.env.VUE_APP_NEW_URL + '/comapi/UploadApi',
      productList: [],
      productTotal: 0,
      productPage: 1,
      productPageSize: 50,
      productKeyword: '',
      productHasMore: false,
      productLoading: false,
      productSearchTimer: null,
      productsLoaded: false,
      levelOptions: [
        { id: "0", name: "0" },
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
      ],
      rules: {
        name: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
          { max: 64, message: "超出最大长度 (64)", trigger: "blur" },
        ],
        number: [
          { required: true, message: "请输入批次", trigger: "blur" }
        ],
        produce_time: [
          { required: true, message: "请选择召回日期", trigger: "change" }
        ],
        reason: [
          { required: true, message: "请输入召回原因", trigger: "blur" }
        ]
      },
      loading: false,
      localVisible: this.visible,
      innerForm: this.form,
    };
  },
  watch: {
    visible(v) {
      this.localVisible = v;
      if (v && !this.productsLoaded) {
        this.productsLoaded = true;
        this.loadProducts(false);
      }
    },
    form(v) { this.innerForm = v; },
  },
  methods: {
    loadProducts(isLoadMore) {
      if (!isLoadMore) {
        this.productPage = 1;
        this.productList = [];
      }
      this.productLoading = true;
      const params = { page: this.productPage, page_size: this.productPageSize };
      if (this.productKeyword) params.search = this.productKeyword;
      goodsInformationList(params).then(res => {
        const items = res.results || [];
        this.productTotal = res.count || 0;
        this.productList = isLoadMore ? [...this.productList, ...items] : items;
        this.productHasMore = this.productList.length < this.productTotal;
      }).finally(() => {
        this.productLoading = false;
      });
    },
    handleProductSearch(val) {
      this.productKeyword = val;
      if (this.productSearchTimer) clearTimeout(this.productSearchTimer);
      this.productSearchTimer = setTimeout(() => this.loadProducts(false), 300);
    },
    handleProductPopupScroll(e) {
      const { target } = e;
      if (target.scrollHeight - target.scrollTop <= target.clientHeight + 10 && this.productHasMore && !this.productLoading) {
        this.productPage++;
        this.loadProducts(true);
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleChangeProductName() {
    },
    handleChange(val) {
      this.$set(this.innerForm.others, 'ID_image', val);
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const func = this.innerForm.id ? callBackEdit : callBackAdd;
          if (this.innerForm.others.ID_image) {
            const images = this.innerForm.others.ID_image
              .filter((item) => item.status && item.status === 'done')
              .map((item) => {
                if (item.url) return item.url;
                return item.response.data.file_url;
              });
            this.innerForm.others.ID_image = images;
          }
          func(this.innerForm)
            .then(() => {
              this.$message.success(this.innerForm.id ? "修改成功" : "新增成功");
              this.$emit(this.innerForm.id ? "update" : "create");
              this.cancel();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    cancel() {
      if (this.productKeyword) {
        this.productKeyword = '';
        this.productsLoaded = false;
      }
      this.$emit("cancel", false);
    },
  },
};
</script>

<style scoped></style>
